module.exports = __webpack_public_path__ + "img/baht_unit.924da5d5.svg";